export default __webpack_public_path__ + "static/media/i_wdt_c_3.09cb0ec7.mp3";